import "./Button.scss";
import { ReactComponent as IconGoogle } from "images/google.svg";

interface IButtonProps {
  variant?: "primary" | "secondary" | "contrast" | "secondary-reverse";
  onClick?: () => void;
  text: string;
  className?: string;
  type?: "button" | "submit" | "reset";
  google?: boolean;
  endIcon?: React.ReactNode;
}

export const Button = ({
  variant = "primary",
  onClick,
  text,
  className,
  google,
  endIcon,
  type = "button",
}: IButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`button ${variant} ${className}`}
    >
      {google && <IconGoogle />}
      <span>{text}</span>
      {endIcon && endIcon}
    </button>
  );
};
